import React, {useEffect, useState} from "react"
import {useLocation} from "react-router-dom"
import {Box} from "@mui/material"
import SideBarLayout from "src/v2/layout/side-bar-layout"
import FormHeader from "../components/FormHeader"
import {ReactComponent as WarningIcon} from "src/v2/assets/icons/warning-error-icon.svg"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"
import MotorService from "../../../../services/motor-service"
import {dispatchSnackbar} from "../../../components/SnackBar/snackbar-bus"
import TabsWrappedLabel from "../../../components/tabs/tabs-component"
import ParametrosPage from "./Parametros/parametros-page"
import EventosOrdinariosPage from "./EventosOrdinarios/eventos-ordinarios-page"
import EventosExtraordinariosPage from "./EventosExtraordinarios/eventos-extraordinarios-page"

const HEADER_DEFAULT = {
    title: `CETIP - | VER -}`,
    statusIcon: <WarningIcon/>,
    statusColor: "Em Andamento",
    statusLabel: "white",
}

const PARAMETRO_TAB = 'parametros'
const EVENTOS_ORDINARIOS_TAB = 'eventos-ordinarios'
const EVENTOS_EXTRAORDINARIOS_TAB = 'eventos-extraordinarios'
const VALIDACAO_TAB = 'validacao'

export const MotorCadastroEventosPage = () => {
    const location = useLocation()
    const state = location.state

    const pageTitle = "Cadastro de Eventos"
    const [header, setHeader] = useState(HEADER_DEFAULT)
    const [cetip, setCetip] = useState(null)
    const [versaoDocumento, setVersaoDocumento] = useState(null)
    const [caracteristica, setCaracteristica] = useState(null)
    const [idCaracteristica, setIdCaracteristica] = useState(null)
    const [loading, setLoading] = useState(false)
    const motorService = new MotorService()
    const [tabValue, setTabValue] = useState(PARAMETRO_TAB)

    const [parametrosProducao, setParametrosProducao] = useState(false)
    const [eventosProducao, setEventosProducao] = useState(false)
    const [eventosExtraordinariosProducao, setEventosExtraordinariosProducao] = useState(false)
    const [eventosProjetados, setEventosProjetados] = useState(null)

    useEffect(() => {
        const {RendaFixaCaracteristicasID, Status, CETIP, VersaoDocumento} = state
        defineHeader(Status, CETIP, VersaoDocumento)
        loadCaracteristicas(RendaFixaCaracteristicasID)
        loadPage(RendaFixaCaracteristicasID, CETIP, VersaoDocumento)
    }, [])

    useEffect(() => {
        const {origem, RendaFixaCaracteristicasID, CETIP, VersaoDocumento} = state
        if (origem === "ver") {
            loadPage(RendaFixaCaracteristicasID, CETIP, VersaoDocumento)
        }
    }, [])

    const setCadastroProducao = (producao) => {
        if (producao) {
            setHeader({
                ...header,
                statusLabel: "EM PRODUÇÃO",
                statusIcon: <CheckIcon/>
            })
        }
    }

    const projetarEventos = (eventos) => {
        setEventosProjetados(eventos)
        setTabValue(EVENTOS_ORDINARIOS_TAB)
    }

    const parametrosComponent = <ParametrosPage
        producao={parametrosProducao}
        setProducao={setParametrosProducao}
        idCaracteristica={idCaracteristica}
        loading={loading}
        eventosState={state}
        setLoading={setLoading}
        projetarEventos={projetarEventos}
        caracteristica={caracteristica}
    />

    const eventosOrdinariosComponent = <EventosOrdinariosPage
        idCaracteristica={idCaracteristica}
        producao={eventosProducao}
        setProducao={(value) => {
            setEventosProducao(value)
            setCadastroProducao(value)
        }}
        loading={loading}
        setLoading={setLoading}
        cetip={cetip}
        versaoDocumento={versaoDocumento}
        caracteristica={caracteristica}
        eventosProjetados={eventosProjetados}
    />

    const eventosExtraordinariosComponent = <EventosExtraordinariosPage
        idCaracteristica={idCaracteristica}
        loading={loading}
        setLoading={setLoading}
        cetip={cetip}
        eventosProducao={eventosExtraordinariosProducao}
        setEventosProducao={setEventosExtraordinariosProducao}
        versaoDocumento={versaoDocumento}
        caracteristica={caracteristica}
    />

    const tabsData = [
        {value: PARAMETRO_TAB, label: 'PARÂMETROS', content: parametrosComponent},
        {value: EVENTOS_ORDINARIOS_TAB, label: 'EVENTOS ORDINÁRIOS', content: eventosOrdinariosComponent},
        {value: EVENTOS_EXTRAORDINARIOS_TAB, label: 'EVENTOS EXTRAORDINÁRIOS', content: eventosExtraordinariosComponent},
        {value: VALIDACAO_TAB, label: 'VALIDAÇÃO', content: null},
    ]

    const defineHeader = (Status, CETIP, VersaoDocumento) => {
        let title = `${CETIP} | VER ${VersaoDocumento}`
        let status = "Em Andamento"
        let color = "warning"
        let icon = <WarningIcon/>

        if (Status === "Em Produção") {
            setCadastroProducao(true)
        }

        setHeader({
            title: title,
            statusLabel: status.toUpperCase(),
            statusColor: color,
            statusIcon: icon
        })
    }

    const loadCaracteristicas = (RendaFixaCaracteristicasID) => {
        motorService.getCadastro(RendaFixaCaracteristicasID)
            .then((response) => {
                const {body} = response
                setCaracteristica(body)
            })
            .catch((error) => {
                dispatchSnackbar("Não foi possível carregar os dados de cadastro", "error")
                console.log(error)
            })
            .finally(() => {
            })
    }

    const loadPage = (idCaracteristica, CETIP, VersaoDocumento) => {
        setIdCaracteristica(idCaracteristica)
        setCetip(CETIP)
        setVersaoDocumento(VersaoDocumento)
    }

    return (
        <SideBarLayout
            title={pageTitle}
            loading={loading}
            header={true}
            headerTitle=""
            headerImage={"/background/eventos_headers.jpg"}
            headerPosition={"1% 41%"}
        >
            <Box
                sx={{
                    marginTop: -14.5,
                    paddingBottom: 5,
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    px: {xxxs: 3, md: 3, lg: 0},
                }}
            >
                <Box mb={4}>
                    <FormHeader
                        title={header.title}
                        statusLabel={header.statusLabel}
                        statusColor={header.statusColor}
                        statusIcon={header.statusIcon}
                    />
                </Box>
            </Box>
            <Box sx={{mt: -9, position: 'relative', zIndex: 2}}>
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <TabsWrappedLabel
                        value={tabValue}
                        onChange={(_, value) => setTabValue(value)}
                        tabs={tabsData} noReload={true}/>
                </Box>
            </Box>
        </SideBarLayout>
    )
}

export default MotorCadastroEventosPage
